import {
    IExperienceTemplate,
    ITimelineItem,
    PARTICIPANT_ACTOR_KEY
} from '@dadohr/shared/domainTypes/experience';
import { getItemDisplayName, resolveExpTitle } from '../../helpers/adminName';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { TimelineItemTitleWithSuperTile } from '../../../../components/Timeline';
import { FlexContainer } from '../../../../layout/Flex';
import { AutomationTimelineItem, TaskTimelineItem } from '../../pages/Details/TaskTimeline';
import { useActorDescriptorsFromTemplate } from '../Actors';
import { TaskBuilderContext } from '../Builders/TaskBuilder/types';
import { MessageItem2 } from '../Messages';

const sortTriggeredItems = (triggeredItems: ITimelineItem[]) => {
  return orderBy(triggeredItems, [
    (x) => {
      if (x.itemType === 'AUTOMATION') {
        return 'zzzzzzzzzz';
      }
      if (x.item.actor === PARTICIPANT_ACTOR_KEY) {
        return '00000000';
      }
      if (x.item.actor === 'manager' || x.item.actor === 'mentor') {
        return '00000001';
      }
      return x.item.actor;
    },
    (x) => {
      if (x.itemType === 'MSG') {
        return 1;
      }
      if (x.itemType === 'TASK') {
        return 2;
      }
      if (x.itemType === 'AUTOMATION') {
        return 3;
      }
      return Infinity;
    }
  ]);
};

export const TriggeredItemsList = ({
  triggeredItems,
  onGoToOtherItem,
  tplContext
}: {
  triggeredItems: ITimelineItem[];
  onGoToOtherItem?: (item: ITimelineItem) => void;
  tplContext: TaskBuilderContext | IExperienceTemplate;
}) => {
  const context = useMemo(() => {
    if ('templateId' in tplContext) {
      return tplContext as TaskBuilderContext;
    }
    
    const experienceTemplate = tplContext as IExperienceTemplate;
    return {
      templateId: experienceTemplate.id,
      orgId: experienceTemplate.orgId,
      title: experienceTemplate.title,
      adminTitle: experienceTemplate.adminTitle,
      contacts: experienceTemplate.contacts,
      notificationSender: experienceTemplate.notificationSender,
      supportingActors: experienceTemplate.supportingActors,
      status: experienceTemplate.status,
      anchor: experienceTemplate.anchor,
      tz: experienceTemplate.tz,
      orgOverrides: experienceTemplate.overrides?.org || null,
      tasks: experienceTemplate.tasks
    } as TaskBuilderContext;
  }, [tplContext]);

  const actorDescriptors = useActorDescriptorsFromTemplate(
    context.supportingActors
  );
  
  return (
    <FlexContainer
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
      fullWidth
    >
      {sortTriggeredItems(triggeredItems).map((x) => {
        const onClick = onGoToOtherItem ? () => onGoToOtherItem(x) : undefined;
        if (x.itemType === 'TASK') {
          return (
            <TaskTimelineItem
              title={
                <TimelineItemTitleWithSuperTile
                  title={resolveExpTitle(getItemDisplayName(x.item), context.title)}
                  superTitle={actorDescriptors[x.item.actor]?.label || ''}
                />
              }
              channels={x.item.channels}
              actor={actorDescriptors[x.item.actor]}
              deactivated={x.item.deactivated}
              onClick={onClick}
              style={{ width: '100%' }}
              hideChannelIcons
            />
          );
        }
        if (x.itemType === 'AUTOMATION') {
          return (
            <AutomationTimelineItem
              tpl={x.item}
              onClick={onClick}
              style={{ width: '100%' }}
            />
          );
        }
        if (x.itemType === 'MSG') {
          return (
            <MessageItem2
              tplContext={context} // Use the normalized context here
              message={x.item}
              actor={actorDescriptors[x.item.actor]}
              style={{ width: '100%' }}
              onClick={onClick}
              showActorLabel
              hideChannelIcons
            />
          );
        }
        return null;
      })}
    </FlexContainer>
  );
};